import React, { useEffect, useState, useRef } from "react";
import ToggleButton from "../ToggleButton";
import Button from "../common/Button";
import DateRangePicker from "../DateRangePicker/index";
import Dropdown from "../../components/common/Dropdown";
import { Box, Grid, Rating, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useDispatch, useSelector } from "react-redux";
import "./feedBackFilter.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { API, CONSTANTS_DATA, APP_ROUTES } from "../../globals/constants";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import {
  FeedbackListingPageFilter,
  filterList,
} from "../../redux/filter/FilterRedux";
import { hideFilter } from "../../redux/features/trainingCenter";
import Cookies from "universal-cookie";

const FeedBackFilter = (props) => {
  const {
    toggleFunction,
    trainingList,
    instructorList,
    filterShow,
    nameFilter,
  } = props;
  let [showFilter, setShowFilter] = useState(true);
  const dispatch = useDispatch();
  const [trainingName, setTrainingName] = useState();
  const navigate = useNavigate();
  const [instructor, setInstructor] = useState();
  const [name, setName] = useState();
  const selectInputRef = useRef();
  const cookies = new Cookies();
  const loginData = cookies.get("loginData");
  let userID = loginData?.id;
  let userRole = loginData?.role_code;
  const [optionlist, setOptionlist] = useState(false);

  const gotoCreateFeedback = () => {
    navigate(APP_ROUTES.CREATE_FEEDBACK, { state: {} });
  };

  const gotoFeedBackTemplateView = () => {
    navigate(APP_ROUTES.FEEDBACK_TEMPLATE_LISTING, { state: {} });
  };

  //   useEffect(() => {
  //     let body = { trainingName, instructor, name };
  //     dispatch(FeedbackListingPageFilter(body));
  //     console.log("instructorList", instructorList);
  //   }, [trainingName, instructor, name]);

  const clearButton = () => {
    dispatch(FeedbackListingPageFilter({}));
    setTrainingName();
    setOptionlist(!optionlist);
    setInstructor();
    setName();
    // console.log('Inside Clear Button');
    // console.log(
    // 	'document >>> ',
    // 	document.getElementById('FeedbackCLearFilterInstructor')
    // );
    document.getElementById("FeedbackCLearFilter").click();
    document.getElementById("FeedbackCLearFilterInstructor").click();
    // document.getElementById('FeedbackClearTraining').click();
    // setShowFilter(!showFilter);
  };

  // const filterShow = () => {
  // 	setShowFilter(!showFilter);
  // 	dispatch(hideFilter(showFilter));
  // };
  useEffect(() => {
    nameFilter(name);
  }, [name]);
  return (
    <>
      <Grid container>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Grid
            container
            direction="row"
            justifyContent={{ xs: "flex-start", md: "flex-start" }}
            alignItems="center"
            columnSpacing={2}
            className="feedback_title"
            marginTop={"1%"}
          >
            <Grid item xs={6} sm={9} md={9} lg={7}>
              {" "}
              {/* <Typography className="image_heading">
								Student Feedback
							</Typography>{' '} */}
              <span className="larger_f_bold">Student Feedback</span>
            </Grid>

            <Grid item className="feedback_toggle">
              <ToggleButton onClick={toggleFunction} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={8} lg={8}>
          <Grid container className="search_container">
            <div className="search_input">
              <Grid item xs={12} sm={6} md={5} lg={10}>
                <input
                  type="text"
                  className="Filter_Search small_f"
                  placeholder="Search"
                  aria-label="Recipient's username with two button addons"
                  onChange={(e) => setName(e.target.value)}
                />
              </Grid>
            </div>
            <div className="search_filter">
              <Grid item xs={12} sm={6} md={1} lg={2}>
                {/* <input
									id="clearFilterSF"
									type="button"
									value="Filter"
									className="Filter_Button small_f"
									onClick={
										() => filterShow() /*() => setShowDateFilter(true)'*/}
                {/* > */}
                {/* </input> */}
                <Button
                  id="clearFilterSF"
                  value="Filter"
                  role="filter"
                  onClick={() => {
                    filterShow();
                  }}
                />
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Grid>
      {/* <Grid container className="datepickercontainer_filter">
				<Grid item xs={0} sm={0} md={0} lg={0}></Grid>
				<Grid item xs={12} sm={12} md={12} lg={12}>
					<Grid container justifyContent="space-around">
						<Grid item xs={12} sm={12} md={6} lg={6}>
							<DateRangePicker />
						</Grid>
						<Grid container xs={12} sm={12} md={6} lg={6} columnSpacing={2}>
							{userRole === 'SUPER_ADMIN' || userRole === 'STUDIO_ADMIN' ? (
								<Grid item xs={12} sm={6} md={6} lg={4}>
									<Dropdown
										ref={selectInputRef}
										placeholder="Select Instructor"
										options={instructorList}
										onChange={(e) => {
											setInstructor(e.value);
											//console.log('eeeee:::', e);
											if (optionlist) {
												setOptionlist(false);
											}
										}}
										clearID={'FeedbackCLearFilterInstructor'}
										clearable
										value={optionlist ? '' : selectInputRef?.current?.value}
										selection
									/>
								</Grid>
							) : (
								''
							)}
							<Grid item xs={12} sm={6} md={6} lg={4}>
								<Dropdown
									ref={selectInputRef}
									placeholder="Select Training name"
									options={trainingList}
									clearable
									selection
									onChange={(e) => {
										setTrainingName(e.value);
										if (optionlist) {
											setOptionlist(false);
										}
									}}
									clearID={'FeedbackCLearFilter'}
									value={optionlist ? '' : selectInputRef?.current?.value}
								/>
							</Grid>
							<Grid item lg={4}>
								<Button
									//id="FeedbackCLearFilter"
									className="fs-4"
									value="Clear Filter"
									role="clearFilter"
									onClick={() => {
										clearButton();
									}}
								/>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid> */}
    </>
  );
};

export default FeedBackFilter;
